import { render, staticRenderFns } from "./Declarations.vue?vue&type=template&id=13a89f9f"
import script from "./Declarations.vue?vue&type=script&lang=js"
export * from "./Declarations.vue?vue&type=script&lang=js"
import style0 from "./Declarations.vue?vue&type=style&index=0&id=13a89f9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports